import { postReq, getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel } from "@/models/core.model";
import { PointTransaction, ManualGrantPointsRequest, ManualDeductPointsRequest, PointTransactionPaginationFilter, pointTransactionFromJson } from '@/models/point-transaction.model';

export const getPagedPointTransactions = async (input: PointTransactionPaginationFilter): Promise<PagedResponseModel<PointTransaction>> => {
  return await getReq(createUrl("a/Point/Transaction/PagedData"),
    { params: input }
  ).then((res: any) => ({
    ...res.data,
    result: res.data.result.map((itm: any) => pointTransactionFromJson(itm))
  }));
};

export const manualGrantPoints = async (input: ManualGrantPointsRequest): Promise<BaseResponseModel<any>> => {
  return await postReq(createUrl("a/Point/Grant"),
    input
  ).then((res: any) => res.data);
};

export const manualDeductPoints = async (input: ManualDeductPointsRequest): Promise<BaseResponseModel<any>> => {
  return await postReq(createUrl("a/Point/Deduct"),
    input
  ).then((res: any) => res.data);
};
